import React from 'react';
import { Alert, Typography, Link as MuiLink } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const SMSConsentDisclosure: React.FC = () => (
  <Alert severity="info" sx={{ mb: 2 }}>
    <Typography variant="body2">
      By providing your phone number, you consent to receive SMS verification
      codes from Art Legacy Institute. Message frequency: typically 1-2 per
      sign-in session. Message and data rates may apply. Reply STOP to cancel.
      Reply HELP for help. See our{' '}
      <MuiLink component={RouterLink} to="/terms" target="_blank">
        Terms of Service
      </MuiLink>{' '}
      and{' '}
      <MuiLink component={RouterLink} to="/privacy" target="_blank">
        Privacy Policy
      </MuiLink>
      .
    </Typography>
  </Alert>
);

export default SMSConsentDisclosure;
